export default __webpack_public_path__ + "static/media/VIDEO_2026.2e6fb366.webm";